import * as React from 'react';
import styled from 'styled-components';
import Colours from '../State/Colours';
import devices from '../State/Devices';

export function TextToSelectOption (text: string) {
    return {
        id: text,
        label: text,
        value: text,
    };
}

export interface InterfaceOption {
    id: string | number
    label: React.ReactNode
    value: any
}

export interface ISelect {
    defaultOption?: InterfaceOption
    options: InterfaceOption[]
    selectedValue?: any
    style?: any
    onChange?: React.FormEventHandler
    onClick?: React.FormEventHandler
    disabled?: boolean
}

class SelectComponent extends React.Component <ISelect, any> {
    public render() {
        const { defaultOption, options, selectedValue, style, onChange, onClick, ...otherProps } = this.props;

        return (
            <select className="Select" value={selectedValue} style={style} onChange={onChange} onClick={onClick} {...otherProps}>
                {defaultOption && <option value={defaultOption.value}>{defaultOption.label}</option>}
                {options.map(({ id, value, label }) => <option key={id} value={value}>{label}</option>)}
            </select>
        );
    }
}

export const Select = styled(SelectComponent)`
    appearance: none;
    font-size: 1em; 
    padding: 4px 16px;
    overflow: hidden;
    border: 1px solid ${Colours.inactive};
    box-sizing: border-box;
    height: 36px;
    max-height: 36px;
    width: 100%;

    opacity: ${({ disabled }) => disabled === true ? 0.5 : 1};
    background-color: ${({ disabled }) => disabled === true ? 'lightgray' : 'white'};
    color: ${({ disabled }) => disabled === true ? 'gray' : Colours.text};
    border: 1px solid ${({ disabled }) => disabled === true ? 'gray' : Colours.gray};

    &:focus {
        border: 1px solid ${Colours.secondary};
        outline: none;
    }

    @media ${devices.laptop} {
        padding: 2px 8px;
    }
`;


// WEBPACK FOOTER //
// ./src/Components/Select.tsx